"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getResponseBodyAsString = exports.noopLogger = exports.callbackStore = exports.combineInits = exports.isInIframe = exports.getCookie = void 0;
exports.buildPath = buildPath;
const react_router_dom_1 = require("react-router-dom");
/**
 * Extract the value of a cookie ie: Given document.cookie = apple=VAL1;
 * banana=VAL2; pear=VAL3 getCookie("banana") will return VAL2
 */
const getCookie = (name) => {
    const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
    if (match)
        return match[2];
    return "";
};
exports.getCookie = getCookie;
const isInIframe = () => {
    try {
        return window.self !== window.top;
    }
    catch (_a) {
        return true;
    }
};
exports.isInIframe = isInIframe;
/**
 * Takes a path with variable params, params and a query string and returns a
 * full valid URL path.
 */
function buildPath(init) {
    var _a;
    let path = (0, react_router_dom_1.generatePath)(init.path, init.params);
    if (init.query) {
        path += (_a = init.query) !== null && _a !== void 0 ? _a : "";
    }
    return path;
}
/**
 * Takes an array of RequestInit objects and combines them together. The
 * top-level attributes of the init object are combined and the headers of each
 * init are combined. In all cases inits that come later in the array take
 * override those that came before.
 */
const combineInits = (inits) => {
    return inits.reduce((combined, next) => {
        return Object.assign(Object.assign(Object.assign({}, combined), next), { headers: Object.assign(Object.assign({}, combined.headers), next.headers) });
    }, {});
};
exports.combineInits = combineInits;
/**
 * Provides mechanism for adding/removing callbacks and then emitting data to
 * all callbacks
 */
const callbackStore = () => {
    const store = new Set();
    return {
        register: (cb) => {
            store.add(cb);
            return () => store.delete(cb);
        },
        emit: (value) => __awaiter(void 0, void 0, void 0, function* () {
            for (const cb of store) {
                yield cb(value);
            }
        }),
    };
};
exports.callbackStore = callbackStore;
// eslint-disable-next-line @typescript-eslint/no-empty-function -- noop logger does nothing
const noop = () => { };
exports.noopLogger = {
    onRequestStart: noop,
    onSuccessResponse: noop,
    onHttpError: noop,
    onNetworkError: noop,
    onFetchRetry: noop,
    onClientError: noop,
};
const getResponseBodyAsString = (response) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const json = yield response.clone().json();
        if (typeof json === "string") {
            return json;
        }
        else if (json.message) {
            return json.message;
        }
        else {
            return "";
        }
    }
    catch (_a) {
        // We couldn't get the error message from the JSON response so carry on
        // and try just getting the response as text...
    }
    try {
        const text = yield response.clone().text();
        return text;
    }
    catch (_b) {
        // Getting the response as text didn't work either... sad. Admit defeat
        // and return a fallback error message.
    }
    return "";
});
exports.getResponseBodyAsString = getResponseBodyAsString;
//# sourceMappingURL=helpers.js.map